module.exports = __webpack_public_path__ + "static/media/streamlined-root.06579e72.png";